import { useEffect, useState } from "react";
import { Button, Flex, Form, Input, Modal, Select, Space, Typography } from "antd";
import disableStoreReasons from "../../../constants/disableStoreReasons";

const { Text, Paragraph } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required ? <Text type="danger">*</Text> : ''}
  </>
);

export default function DeliverySettingsDisableDialog({
  showDisableDialog,
  setShowDisableDialog,
  handleSave,
  handleClose,
  isSubmitting
}) {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [hasFormError, setHasFormError] = useState(false);

  useEffect(() => {
    if (!isSubmitting && isLoading) {
      form.resetFields();
    }
  }, [form, isSubmitting, isLoading]);

  const handleCancel = () => {
    form.resetFields();
    setHasFormError(false);
    setShowDisableDialog(false);
    handleClose();
  };

  const onFinish = (values) => {
    handleSave(values);
    setHasFormError(false);
    setIsLoading(true);
  };

  return (
    <Modal
      title="Disable Service?"
      closable={false}
      centered={true}
      open={showDisableDialog}
      onClose={handleClose}
      footer={null}
      styles={{
        content: {
          paddingBottom: "1px"
        }
      }}
    >
      <Paragraph>Before confirming, please tell us why you're disabling this service.</Paragraph>
      <Form
        layout="vertical"
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        onFinishFailed={() => setHasFormError(true)}
        requiredMark={customizeRequiredMark}
      >
        <Form.Item
          name="reason"
          label="Reason"
          rules={[{ required: true, message: "This is a required field" }]}
        >
          <Select
            placeholder="Please select"
            allowClear
            disabled={isSubmitting}
          >
            {
              disableStoreReasons.map((reason, index) => (
                <Option key={index} value={reason.value}>{reason.name}</Option>
              ))
            }
          </Select>
        </Form.Item>
        <Form.Item
          name="notes"
          label="Notes"
          rules={[{ required: true, message: "Note is required" }]}
        >
          <TextArea disabled={isSubmitting} />
        </Form.Item>
        <Form.Item>
          <Flex
            gap={50}
            justify={hasFormError ? "space-between" : "flex-end"}
            style={{ marginTop: hasFormError ? "10px" : undefined }}
          >
            {
              hasFormError ?
                <Text type="danger">Please check the fields marked in red and try again.</Text>
                : null
            }

            <Space size={"middle"}>
              <Button
                htmlType="button"
                disabled={isSubmitting}
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                htmlType="submit"
                color="danger"
                variant="solid"
                loading={isSubmitting}
                disabled={isSubmitting}
              >
                Confirm
              </Button>
            </Space>
          </Flex>
        </Form.Item>
      </Form>
    </Modal>
  );
};
